import {renderElement} from "../utils/common";
import {getTemplate} from "./templates";

export const EventType = {
  DEADLINE: `DEADLINE`,
  RESPONSIBLE: `RESPONSIBLE`,
  AUTHOR: `AUTHOR`,
  PRIORITY: `PRIORITY`,
  CALL_USER: `CALL_USER`,
  CLOSE: `CLOSE`,
  OPEN: `OPEN`,
};

class Events {
  private eventEmitter = window.taskEmitter;
  private readonly listElement: HTMLElement;

  constructor(element: HTMLElement) {
    this.listElement = element;

    if (this.listElement) {
      this.addEvent = this.addEvent.bind(this);

      this.init();
    }
  }

  private init() {
    this.eventEmitter.on(`events.render`, this.addEvent);
  }

  addEvent(type: string, options: unknown) {
    renderElement(this.listElement, getTemplate(type, options), true);
  }
}

export {Events};
